import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import Header from "../../Component/AppComponent/Header/Header";
import PageTemplate from "../../Component/MainComponent/PageTemplate/PageTemplate";
import PlantPopup from "../../Component/AppComponent/Popup/PlantPopup";
import {
  setplantListRetrieveActions,
  plantid,
  setCommonPostActions,
  SetCommonPostUpdateResponse,
  CreatePlantUpdateResponse,
  UpdatePlantScheduleResponse,
} from "../../Redux/Slice";
import Delete from "../../Component/AppComponent/Popup/Delete";
import ReactTable from "../../Component/AppComponent/Table";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { plantlist } from "../../Context/apidata";
import axios from "axios";

function PlantProject() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const CommonPostResData = useSelector(
    (state) => state.CommonPostData.CommonPost
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [plantPopup, setPlantPopup] = useState(false);
  const plantNames = useSelector((state) => state.fetchPlant);
  const [editPayload, setEditPayload] = useState("");
  const [selectedPlantId, setSelectedPlantId] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [tabledata, settabledata] = useState([]);
  const [plantcommon, setplantcommon] = useState(false);
  const [plantdetails, setplantdetails] = useState();
  const [plantCommonFolder, setplantCommonFolder] = useState([
    "PF_CHALLAN",
    "ESI_CHALLAN",
  ]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [id, setid] = useState("");
  const createPlantdata = useSelector((state) => state.createPlant);
  const updatePlantdata = useSelector((state) => state.updatePlant);
  useEffect(() => {
    //console.log(createPlantdata,updatePlantdata,"ooo")

    if (createPlantdata?.createPlant?.data) {
      dispatch(
        setplantListRetrieveActions({
          search: searchQuery,
          page: dtpageindex,
        })
      );
      dispatch(CreatePlantUpdateResponse());
    }
    if (updatePlantdata?.updatePlantData?.data) {
      dispatch(
        setplantListRetrieveActions({
          search: searchQuery,
          page: dtpageindex,
        })
      );
      dispatch(UpdatePlantScheduleResponse());
    }
  }, [createPlantdata, updatePlantdata]);
  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;

    if (isChecked) {
      setCheckedItems([...checkedItems, itemName]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== itemName));
    }
  };

  useEffect(() => {
    //console.log(plantNames?.plantListRetrieve, "plantdetails")
    if (plantNames.plantListRetrieve?.data?.length > 0) {
      settabledata(plantNames.plantListRetrieve.data);
      setdatacount(plantNames.plantListRetrieve.values);
    } else {
      settabledata([]);
      setdatacount(0);
    }
  }, [plantNames]);
  useEffect(() => {
    dispatch(
      setplantListRetrieveActions({
        search: searchQuery,
        page: dtpageindex,
      })
    );
  }, [dtpageindex, searchQuery]);
  const handleEdit = (value) => {
    setEditPayload({
      plant: value.plant,
      plant_common: value.plant_common,
      emails: value.emails,
    });
    setSelectedPlantId(value.id);
    setPlantPopup(true);
  };
  const handleRefresh = () => {
    dispatch(
      setplantListRetrieveActions({
        search: searchQuery,
        page: dtpageindex,
      })
    );
  };
  const handleView = (value) => {
    //plantid
    dispatch(plantid(value.id));
    navigate(`/projects/${value.id}`);
  };
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
  ];
  const handleDelete = (value, e) => {
    setDeletePopup(true);
    setid(value);
    //console.log(value,"Delete form ");
  };
  const handleConfirmDelete = (value) => {
    //console.log(value,"connect Successful");
    axios({
      method: "delete",
      url: plantlist,
      params: {
        id: id.id,
      },
    })
      .then((res) => {
        toast.info(`Deleted Successfully`, {
          position: toast.POSITION.TOP_RIGHT,
          className: "toast-message",
        });
        dispatch(
          setplantListRetrieveActions({
            search: searchQuery,
            page: dtpageindex,
          })
        );
      })
      .catch((err) => {
        //console.log(err)
        toast.info(` ${err.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
          className: "toast-message",
        });
      });
    setDeletePopup(false);
  };
  const plantColumn = useMemo(
    () => [
      {
        Header: "Plant",
        accessor: "plant",
      },
      {
        Header: "Project Count",
        accessor: "project_count",
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="plantProjectActions">
              <button
                type="button"
                onClick={(e) => handleEdit(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-solid fa-pen"
                    style={{
                      fontSize: "13px",
                      paddingRight: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Edit{" "}
                </span>
              </button>
              <button
                type="button"
                onClick={(e) => handleDelete(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Delete{" "}
                </span>
              </button>
              <button
                type="button"
                onClick={(e) => handleView(row.row.original, e)}
              >
                <i
                  onClick={(e) => handleView(row.row.original, e)}
                  className="bi bi-eye-fill"
                ></i>{" "}
                View
              </button>
              {/* <button className="plant_common" onClick={(e) => {
                setplantdetails(row.row.original)
                setplantcommon(!plantcommon)
              }}>
                <i class="bi bi-folder-plus"></i>
                Plant Common
              </button> */}
            </div>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleSubmit = () => {
    if (checkedItems.length > 0) {
      dispatch(
        setCommonPostActions({
          type: "plant",
          plant_common: checkedItems,
          plant: plantdetails.plant,
        })
      );
    } else {
      toast.info(`Select Folder`, {
        position: toast.POSITION.TOP_RIGHT,
        className: "toast-message",
      });
    }
  };

  useEffect(() => {
    setplantcommon(false);
    dispatch(SetCommonPostUpdateResponse());
    setCheckedItems([]);
  }, [CommonPostResData]);
  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <Header breadCrumbsData={breadcrumbsData} heading="Plant" />
      <div className="UserDetails" style={{ padding: "0" }}>
        <button
          type="submit"
          style={{
            background:
              "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
          }}
          className="custom-button"
          onClick={() => setPlantPopup(true)}
        >
          CREATE
        </button>
      </div>

      <ReactTable
        columns={plantColumn}
        data={tabledata}
        pagesize={pagesize}
        pageindex={pageindex}
        dtpagesize={dtpagesize}
        dtpageindex={dtpageindex}
        datacount={datacount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        search={true}
      />

      {/* {plantPopup && ( */}
      <PlantPopup
        show={plantPopup}
        setShow={setPlantPopup}
        refresh={handleRefresh}
        editPayload={editPayload}
        selectedPlantId={selectedPlantId}
        setEditPayload={setEditPayload}
        // plantNameId={plantNames.id}
      />
      <Delete
        show={deletePopup}
        setShow={setDeletePopup}
        handleConfirmDelete={handleConfirmDelete}
      />
      {/* )} */}

      {plantcommon && (
        <Modal
          // size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={plantcommon}
          // onHide={handleClose}
          className="modelman"
        >
          <Modal.Header>
            <Modal.Title>Plant Common Folder</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div>
                {plantCommonFolder.map((ele, index) => (
                  <div key={index}>
                    <input
                      type="checkbox"
                      id={ele}
                      name={ele}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={ele}>{ele}</label>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setplantcommon(false);
                setCheckedItems([]);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              style={{ backgroundColor: "#f26639", border: "none" }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default PlantProject;
